import { Checkbox, Stack, Text } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { useState } from 'react';

type Props = {
  message: string;
  /** Valeur initiale de la case « Informer l'utilisateur par e-mail ». */
  defaultNotify: boolean;
  onNotifyChange: (notify: boolean) => void;
};

/** Contenu de la modale de confirmation d'une décision, avec le choix d'informer l'utilisateur. */
const DecisionConfirmContent = ({ message, defaultNotify, onNotifyChange }: Props) => {
  const { t } = useTranslate();
  const [notify, setNotify] = useState(defaultNotify);

  return (
    <Stack gap="md">
      <Text size="sm">{message}</Text>
      <Checkbox
        label={t('admin.affectations.notify.checkbox')}
        checked={notify}
        onChange={event => {
          setNotify(event.currentTarget.checked);
          onNotifyChange(event.currentTarget.checked);
        }}
      />
    </Stack>
  );
};

export default DecisionConfirmContent;
